class AthleteList extends HTMLElement {
  constructor() {
    super();

    const slideWrap = this.querySelector('.js-athlete-list-slide');

    $(slideWrap).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: true,
      centerMode: true,
      centerPadding: '170px',
      touchThreshold:2,
      nextArrow:
        '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" role="img" width="24px" height="24px" fill="none"><path stroke="currentColor" stroke-width="1.5" d="M8.474 18.966L15.44 12 8.474 5.033"></path></svg></button>',
      prevArrow:
        '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" role="img" width="24px" height="24px" fill="none"><path stroke="currentColor" stroke-width="1.5" d="M15.525 18.966L8.558 12l6.967-6.967"></path></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerPadding: '100px'
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '0px',
            centerMode: false,
            arrows: false,
            variableWidth: true,
            autoplay:false,
            autoplaySpeed:2500,
          },
        },
      ],
    });
  }
}

customElements.define(
  "athlete-list",
  AthleteList
);
